<div class="role-min-height" id="roleManagement">
    @if(this.userAuthService.checkPermission('MANAGE.USERS.ROLES'))
    {

      <div class="mt-2 pr-0 col-12 d-flex justify-content-end align-items-center mb-05">
  <button class="add-service-btn" mat-stroked-button (click)="addRole()">+ Add Role
    <mat-icon mat-icon-button matSuffix matTooltip="Click on the button to add a new role"
              aria-hidden="true" matTooltipClass="ey-custom-tooltip"
              matTooltipPosition="below" style="margin-bottom: -3px;  align-items: center; vertical-align: middle; font-size: 18px;">
              info
            </mat-icon>
  </button>
  </div>
    }
    <div class="row">
        <div class="col pb-1">
            @if(totalRecords){
            <span  class="mdc-data-table__header-cell" >
                {{totalRecords}} <em class="selectedRecordText">Total Roles</em>
            </span>
        }
        </div>
    </div>
    <ag-grid-angular #contextMenu [style]="styleChipDiv" class="ag-theme-material role-managementt-grid"
        (gridReady)="onRolesGridReady($event)" [columnDefs]="columnDefs" id="gridRoles"
        [defaultColDef]="defaultColDef" [cacheBlockSize]="cacheBlockSize" [maxBlocksInCache]="maxBlocksInCache"
        [rowModelType]="rowModelType" [sideBar]="sideBar"
        [infiniteInitialRowCount]="infiniteInitialRowCount"
        [overlayNoRowsTemplate]="overlayNoRowsTemplate" [gridOptions]="gridOptions"
        (cellClicked)="tableMenuClick($event, $event.data, contextMenu,rolesMenuTemplate)">
    </ag-grid-angular>

</div>

<ng-template #rolesMenuTemplate let-role>
    <div>
      <ul class="mdc-list demo-list mdc-elevation--z2 b-white">
        @if(role.extraProperties.allowModify && this.userAuthService.checkPermission('MANAGE.USERS.ROLES')){
        <li class="mdc-list-item mdc-ripple-upgraded context-menu-heigth unsetbottommargin removebottommargin"
            (click)="updateRole(role.extraProperties)" (keydown)="noop()" *ngIf="role.extraProperties.allowModify">
          <span class="mdc-fab__icon material-icons context-menu-font-size">edit</span>&nbsp;&nbsp;Modify
        </li>
        }
        @if(!role.extraProperties.isAdmin && !role.extraProperties.isStatic ){
        <li class="mdc-list-item mdc-ripple-upgraded context-menu-heigth unsetbottommargin removebottommargin"
            (click)="deleteDialog(role.extraProperties)" (keydown)="noop()">
          <span class="mdc-fab__icon material-icons context-menu-font-size">delete</span>&nbsp;&nbsp;Remove
        </li>
        }
        @if(!role.extraProperties.isStatic && !role.status && !role.extraProperties.isActive){
        <li class="mdc-list-item mdc-ripple-upgraded context-menu-heigth unsetbottommargin removebottommargin"
            (click)="setRoleStatus(role.extraProperties,true)" (keydown)="noop()">
          <span class="mdc-fab__icon material-icons context-menu-font-size">done</span>&nbsp;&nbsp;Activate Role
        </li>
        }
        @if(!role.extraProperties.isAdmin && !role.extraProperties.isStatic && role.extraProperties.isActive){
        <li class="mdc-list-item mdc-ripple-upgraded context-menu-heigth unsetbottommargin removebottommargin"
            (click)="setRoleStatus(role.extraProperties,false)" (keydown)="noop()">
          <span class="mdc-fab__icon material-icons context-menu-font-size">remove_circle</span>&nbsp;&nbsp;Deactivate
          Role
        </li>
        }
      </ul>
    </div>
</ng-template>
<app-slider [sliderId]="roleSliderId" [sliderDescription]="sliderDescription"
    [sliderHeader]="(editmode == true) ? 'Modify Role' :  'Add Role' " (closeSliderFunc)="closeNav()">
    @if(editmode == false){
    <div>
        <app-add-role (closeSlider)=closeNav() [defaultPermissions]="defaultPermissions"></app-add-role>
    </div>
    }
    @if(editmode == true){
    <div>
        <app-add-role (closeSlider)=closeNav() [defaultPermissions]="defaultPermissions"
            [data]="roleSliderData"></app-add-role>
    </div>
    }
    <ng-content></ng-content>

</app-slider>

<ng-template #sliderContent>
</ng-template>
